import React, {useMemo} from 'react';
import styles from './styles.scss';
import TableRow from './TableRow';
import {
  IToothPositionMovement,
  TeethMovementStage,
  ToothMovementPoints,
} from '@data/models';
import { ITooth } from '@data/models/TreatmentPlan';
import { IToothlikeNameProvider } from '@data/providers/DentalNotationProvider/IToothlikeNameProvider';
import { ToothlikeNameProviderFactory } from '@data/providers/DentalNotationProvider/ToothlikeNameProviderFactory';
import { DentalNotationType } from '@data/providers/DentalNotationProvider/Models';

type TeethMovementTableProps = {
  type: 'upperJaw' | 'lowerJaw';
  isJawVisible: boolean;
  teeth: string[];
  currentStageData: TeethMovementStage;
  currentStage: string;
  toothNumbering: DentalNotationType;
  selectedToothOriginPoint: ToothMovementPoints;
  teethStaticInfo?: ITooth[] | null;
};

const TeethMovementTable = ({
  isJawVisible,
  teeth,
  currentStage,
  currentStageData,
  toothNumbering,
  selectedToothOriginPoint,
  type,
  teethStaticInfo,
}: TeethMovementTableProps) => {
  const toothlikeNameProvider: IToothlikeNameProvider = useMemo(
    () => ToothlikeNameProviderFactory.create(toothNumbering),
    []
  );

  const isUpperJaw = type === 'upperJaw';

  return (
    <div className={styles.teethMovement_table}>
      {isJawVisible &&
        teeth.map((toothNumber: string) => {
          const toothData = currentStageData[toothNumber] ?? [undefined];

          return toothData.map((tooth: IToothPositionMovement) => {
            let displacementData = tooth?.toothMovement;
            
            if (tooth?.displacementPerToothOriginPositions) {
              // legacy: when displacementPerToothOriginPositions used to start with a capital letter
              const matchingKey = Object.keys(tooth.displacementPerToothOriginPositions).find(key =>
                key.toLowerCase() === selectedToothOriginPoint.toLowerCase()
              );
              
              if (matchingKey) {
                displacementData = tooth.displacementPerToothOriginPositions[matchingKey as ToothMovementPoints];
              }
            }
            const toothPosition = tooth?.toothPosition;
            const rowKey =
              `${currentStage}-${toothNumber}` +
              (toothPosition?.relativePosition
                ? `-${toothPosition.toothMapPosition}-${toothPosition.relativePosition}`
                : '');
            
            const toothStaticData = teethStaticInfo?.find(staticTooth => 
              staticTooth.number === +toothNumber
            );
            
            return (
              <TableRow
                key={rowKey}
                data={displacementData}
                toothNumber={
                  tooth?.toothLabel ??
                  toothlikeNameProvider.getName(+toothNumber)
                }
                isFirst={toothNumber === (isUpperJaw ? '18' : '48')}
                isLast={toothNumber === (isUpperJaw ? '28' : '38')}
                movementLimits={toothStaticData?.movementLimits}
              />
            );
          });
        })}
    </div>
  );
};

export default TeethMovementTable;
